import { cartesianProductOfArrays } from 'utils/common-functions/index'
import { divide } from 'number-precision'

// There are 3 horizontals and 12 verticals in this matrix
export const ROULETTE = [[3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36], [2, 5, 8, 11, 14, 17, 20, 23, 26, 29, 32, 35], [1, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34]]

export const ROULETTE_BET_TYPES = {
  STRAIGHT: 'straight',
  SPLIT_HORIZONTAL: 'split-horizontal',
  STREET: 'street',
  CORNER: 'corner',
  LINE: 'line',
  COLUMN: 'column',
  DOZEN: 'dozen',
  ODD_EVEN: 'odd-even',
  COLOR: 'color',
  LOW_HIGH: 'low-high',
  SPLIT_VERTICAL: 'split-vertical'
}

export const ROULETTE_PAYOUTS = {
  1: 36,
  2: 18,
  3: 12,
  4: 9,
  5: 6,
  6: 3,
  7: 3,
  8: 2,
  9: 2,
  10: 2,
  11: 18
}

export const ROULETTE_COLORS_INDICES = {
  1: [[0, 0], [0, 2], [0, 3], [0, 5], [0, 6], [0, 8], [0, 9], [0, 11], [2, 0], [2, 2], [2, 5], [2, 6], [2, 8], [2, 11], [1, 1], [1, 4], [1, 7], [1, 10]],
  2: [[0, 1], [0, 4], [0, 7], [0, 10], [2, 1], [2, 4], [2, 7], [2, 10], [1, 0], [1, 2], [1, 3], [1, 5], [1, 6], [1, 8], [1, 9], [1, 11], [2, 3], [2, 9]]
}

export const FORMAL_NUMBERS = {
  1: '3rd',
  2: '2nd',
  3: '1st'
}

export const ROULETTE_BETS = {
  STRAIGHT: straightNo => {
    if (straightNo < 0 || straightNo > 36) {
      return null
    }
    return [straightNo]
  },
  SPLIT_HORIZONTAL: splitNo => {
    if (splitNo < 1 || splitNo > 33) {
      return null
    }
    const horizontal = Math.ceil(splitNo / 11) - 1
    const vertical = (splitNo - 1) % 11
    return [ROULETTE[horizontal][vertical], ROULETTE[horizontal][vertical + 1]]
  },
  STREET: streetNo => {
    if (streetNo < 1 || streetNo > 12) {
      return null
    }
    const horizontals = [0, 1, 2]
    const verticals = [streetNo - 1]
    const numbers = cartesianProductOfArrays(horizontals, verticals).map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  CORNER: cornerNo => {
    if (cornerNo < 1 || cornerNo > 22) {
      return null
    }
    const horizontals = [Math.ceil(cornerNo / 11) - 1, Math.ceil(cornerNo / 11) - 1 + 1]
    const verticals = [(cornerNo - 1) % 11, (cornerNo - 1) % 11 + 1]
    const numbers = cartesianProductOfArrays(horizontals, verticals).map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  LINE: lineNo => {
    if (lineNo < 1 || lineNo > 11) {
      return null
    }
    const horizontals = [0, 1, 2]
    const verticals = [lineNo - 1, lineNo]
    const cartesian = cartesianProductOfArrays(horizontals, verticals)
    const numbers = cartesian.map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  COLUMN: columnNo => {
    if (columnNo < 1 || columnNo > 3) {
      return null
    }
    const horizontals = [(columnNo - 1)]
    const verticals = Array.from(Array(12).keys())
    const cartesian = cartesianProductOfArrays(horizontals, verticals)
    const numbers = cartesian.map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  DOZEN: dozenNo => {
    // 1 for first 12, 2 for second 12 and 3 for third 12
    if (dozenNo < 1 || dozenNo > 3) {
      return null
    }
    const horizontals = [0, 1, 2]
    const verticals = [0, 1, 2, 3].map(item => (item + (dozenNo - 1) * 4))
    const cartesian = cartesianProductOfArrays(horizontals, verticals)
    const numbers = cartesian.map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  ODD_EVEN: oddOrEven => {
    // 1 for odd, 2 for even
    if (oddOrEven < 1 || oddOrEven > 2) {
      return null
    }
    const numbers = +oddOrEven === 1 ? Array.from(Array(36).keys(), x => x + 1).filter(x => x % 2 === 1) : Array.from(Array(36).keys(), x => x + 1).filter(x => x % 2 === 0)
    return numbers
  },
  COLOR: color => {
    // 1 for red, 2 for black
    if (color < 1 || color > 2) {
      return null
    }
    const numbers = ROULETTE_COLORS_INDICES[color].map(point => ROULETTE[point[0]][point[1]])
    return numbers
  },
  LOW_HIGH: lowOrHigh => {
    // 1 for first 18, 2 for second 18
    if (lowOrHigh < 1 || lowOrHigh > 2) {
      return null
    }
    const horizontals = [0, 1, 2]
    const verticals = [0, 1, 2, 3, 4, 5].map(item => (item + (lowOrHigh - 1) * 6))
    const cartesian = cartesianProductOfArrays(horizontals, verticals)
    const numbers = cartesian.map(item => ROULETTE[item[0]][item[1]])
    return numbers
  },
  SPLIT_VERTICAL: splitNo => {
    if (splitNo < 1 || splitNo > 24) {
      return null
    }
    const horizontal = Math.ceil(splitNo / 12) - 1
    const vertical = (splitNo - 1) % 12
    return [ROULETTE[horizontal][vertical], ROULETTE[horizontal + 1][vertical]]
  }
}

// Remember all the straight bets should be at the last
export const defaultBetDetails = [
  'COLUMN_3', 'COLUMN_2', 'COLUMN_1',
  'DOZEN_1', 'DOZEN_2', 'DOZEN_3', 'ODD_EVEN_1', 'ODD_EVEN_2', 'COLOR_1', 'COLOR_2', 'LOW_HIGH_1', 'LOW_HIGH_2',
  'STRAIGHT_0', 'STRAIGHT_1', 'STRAIGHT_2', 'STRAIGHT_3', 'STRAIGHT_4',
  'STRAIGHT_5', 'STRAIGHT_6', 'STRAIGHT_7', 'STRAIGHT_8', 'STRAIGHT_9',
  'STRAIGHT_10', 'STRAIGHT_11', 'STRAIGHT_12', 'STRAIGHT_13', 'STRAIGHT_14',
  'STRAIGHT_15', 'STRAIGHT_16', 'STRAIGHT_17', 'STRAIGHT_18', 'STRAIGHT_19',
  'STRAIGHT_20', 'STRAIGHT_21', 'STRAIGHT_22', 'STRAIGHT_23', 'STRAIGHT_24',
  'STRAIGHT_25', 'STRAIGHT_26', 'STRAIGHT_27', 'STRAIGHT_28', 'STRAIGHT_29',
  'STRAIGHT_30', 'STRAIGHT_31', 'STRAIGHT_32', 'STRAIGHT_33', 'STRAIGHT_34',
  'STRAIGHT_35', 'STRAIGHT_36'
]

export const initialStateBetDetailsMap = () => {
  const obj = {}
  defaultBetDetails.forEach(item => {
    obj[item] = { chips: 0, amount: 0 }
  })
  return obj
}

export const rouletteNumberColor = (num) => {
  let result
  if (num === 0) {
    return 'colorZero'
  }
  Object.keys(ROULETTE_COLORS_INDICES).forEach(color => {
    if (ROULETTE_COLORS_INDICES[color].some(point => ROULETTE[point[0]][point[1]] === num)) {
      result = +color
    }
  })
  return result === 1 ? 'colorRed' : 'colorSlate'
}

export const showChipsInFormat = chips => {
  if (chips >= 1000) {
    return `${parseInt(divide(chips, 1000))}K${chips % 1000 === 0 ? '' : '+'}`
  }
  if (chips >= 1000000) {
    return `${parseInt(divide(chips, 1000))}M${chips % 1000 === 0 ? '' : '+'}`
  }

  return chips
}

export const getWinningBetTypes = winningNumber => {
  const results = []

  // INFO: Case handled for number zero
  if (winningNumber === 0) {
    return ['Only straight zero win!']
  }
  defaultBetDetails.forEach(betDetail => {
    const lastUnderscoreIndex = betDetail.lastIndexOf('_')

    const betType = betDetail.substring(0, lastUnderscoreIndex)
    const typeDetail = +betDetail.substring(lastUnderscoreIndex + 1)
    const isWin = ROULETTE_BETS[betType](typeDetail).includes(winningNumber)
    let content
    if (isWin) {
      switch (betType) {
        case 'COLUMN':
          content = `${FORMAL_NUMBERS[typeDetail]} Column`
          break
        case 'DOZEN':
          content = `${12 * (typeDetail - 1) + 1} to ${12 * (typeDetail)}`
          break
        case 'ODD_EVEN':
          content = typeDetail === 1 ? 'Odd' : 'Even'
          break
        case 'COLOR':
          content = typeDetail === 1 ? 'Red' : 'Black'
          break
        case 'LOW_HIGH':
          content = typeDetail === 1 ? 'Low' : 'High'
          break
      }
    }
    if (content) {
      results.push(content)
    }
  })
  return results
}

export const defaultBetSelectionRule = {
  COLUMN: { variant: {}, maxValHoldCount: 2, type: 'columnBet', msg: 'COLUMN_BET_SELECTION' },
  DOZEN: { variant: {}, maxValHoldCount: 2, type: 'dozenBet', msg: 'DOZEN_BET_SELECTION' },
  ODD_EVEN: { variant: {}, maxValHoldCount: 1, type: 'oddEvenBet', msg: 'ODD_EVEN_BET_SELECTION' },
  COLOR: { variant: {}, maxValHoldCount: 1, type: 'colorBet', msg: 'COLOR_BET_SELECTION' },
  LOW_HIGH: { variant: {}, maxValHoldCount: 1, type: 'lowHighBet', msg: 'LOW_HI_BET_SELECTION' }
}

export const BET_SELECTION_ACTION_TYPE = {
  ADD_UPDATE: 'add_update',
  UNDO: 'undo',
  CLEAR: 'clear'
}
